// public/js/modules/filters/beacon-filter.js
// Show all assets, only beacon-tracked ones, or only GPS/cellular-tracker ones.
// The old UI had a separate beacons-only map; this folds that into the main map
// as a filter. "Beacon" = the asset carries a BLE device (assignedDevices type
// 'bluetooth'); "Tracker" = it carries a non-bluetooth device (digitalmatter,
// etc.). A mixed asset matches both. Assets with no device match neither of the
// narrowed modes and only show under "All".
const hasBeacon  = (a) => (a.assignedDevices || []).some(d => d.type === 'bluetooth');
const hasTracker = (a) => (a.assignedDevices || []).some(d => d.type && d.type !== 'bluetooth');

export const beaconFilter = {
  id: 'positionSource',
  getDefaultState: () => ({ mode: 'all' }),   // 'all' | 'beacons' | 'trackers'

  renderUI(state) {
    const opt = (val, label) => `
      <div class="form-check">
        <input class="form-check-input" type="radio" name="pos-source" id="ps-${val}" value="${val}" ${state.mode === val ? 'checked' : ''}>
        <label class="form-check-label" for="ps-${val}">${label}</label>
      </div>`;
    return `
      <div class="mb-4">
        <h6 class="fw-bold mb-2">Position source</h6>
        ${opt('all', 'All')}
        ${opt('trackers', 'GPS trackers only')}
        ${opt('beacons', 'Beacons only')}
      </div>`;
  },

  apply(assets, state) {
    if (!state || state.mode === 'all') return assets;
    if (state.mode === 'beacons')  return assets.filter(hasBeacon);
    if (state.mode === 'trackers') return assets.filter(hasTracker);
    return assets;
  },

  attachListeners(container, manager) {
    container.querySelectorAll('input[name="pos-source"]').forEach(rb => {
      rb.addEventListener('change', () => {
        if (rb.checked) manager.updateFilter('positionSource', { mode: rb.value });
      });
    });
  },
};
